import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },

  // ADD_LIST(state, mdMake) {
  //   state.list.push(mdMake);
  // },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
  SET_LOADING_LIST(state, value) {
    state.loading = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  list: (store, params) => {
    store.state.loading = true;
    return Service.get(`charging-station/rates`, params).then((data) => {
      store.commit("SET_META", data.body);
      store.commit("SET_LIST", data.body.data);
      store.state.loading = false;
      return data.body;
    });
  },

  add: (store, { payload, filter }) => {
    store.state.loading = true;
    return Service.post(`charging-station/rates`, payload).then((data) => {
      store.dispatch("list", filter);
      store.state.loading = false;
      return data.body;
    });
  },

  update: (store, params) => {
    store.state.loading = true;
    return Service.put(`charging-station/rates/${params?.id}`, params).then(
      (data) => {
        // store.commit("UPDATE_LIST", data);
        store.state.loading = false;
        return data.body;
      }
    );
  },

  destroy: (store, params) => {
    store.state.loading = true;
    return Service.destroy(`charging-station/rates/${params.id}`).then(
      (data) => {
        store.commit("DELETE_LIST", params);
        store.state.loading = false;
        return data.body;
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const csmsRates = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default csmsRates;
